import React from 'react';
import Icon from '@/components/AppIcon';

const ResumeProcessingStep = ({ progress = 0 }) => {
  const processingStages = [
    { id: 1, label: "Uploading document", completed: progress >= 25 },
    { id: 2, label: "Extracting text content", completed: progress >= 50 },
    { id: 3, label: "Analyzing structure", completed: progress >= 75 },
    { id: 4, label: "Validating information", completed: progress >= 100 }
  ];

  return (
    <div className="space-y-6">
      <div className="step-form-section">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-primary/10 rounded-full mb-4">
            <Icon name="FileSearch" size={40} className="text-primary animate-pulse" />
          </div>
          <h2 className="text-2xl font-semibold text-foreground mb-2">
            Processing Your Resume
          </h2>
          <p className="text-muted-foreground">
            Please wait while we analyze your document...
          </p>
        </div>

        <div className="max-w-md mx-auto space-y-4">
          {processingStages?.map((stage) => (
            <div key={stage?.id} className="flex items-center gap-4">
              <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${
                stage?.completed 
                  ? 'bg-success text-success-foreground' 
                  : 'bg-muted text-muted-foreground'
              }`}>
                {stage?.completed ? (
                  <Icon name="Check" size={16} />
                ) : (
                  <div className="w-2 h-2 bg-current rounded-full animate-pulse" />
                )}
              </div>
              <div className="flex-1">
                <p className={`text-sm font-medium transition-colors duration-300 ${
                  stage?.completed ? 'text-foreground' : 'text-muted-foreground'
                }`}>
                  {stage?.label}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8">
          <div className="progress-bar h-3">
            <div 
              className="progress-bar-fill transition-all duration-500" 
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="text-center text-sm text-muted-foreground mt-2">
            {progress}% Complete
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResumeProcessingStep;